/**
 * Thai locale for main navigation (sidebar + user menu)
 */

export const th = {
  adminDashboard: 'แดชบอร์ดผู้ดูแล',
  searchPlaceholder: 'ค้นหา...',
  createLeads: 'สร้างลีด',
  motorPolicy: 'กรมธรรม์รถยนต์',
  voluntaryInsurance: 'ประกันภัยภาคสมัครใจ',
  leads: 'ลีด',
  policyInProgress: 'กรมธรรม์ที่กำลังดำเนินการ',
  compulsoryInsurance: 'ประกันภาคบังคับ',
  endorsement: 'สลักหลัง',
  nonMotorPolicy: 'Non-Motor Policy',
  nonMotor: 'Non-Motor',
  nonStandardLeads: 'Non-Standard Leads',
  nonStandardPolicies: 'Non-Standard Policies',
  motorbike: 'มอเตอร์ไซค์',
  agents: 'ตัวแทน',
  allAgents: 'ตัวแทนทั้งหมด',
  mlmAgents: 'ตัวแทน MLM',
  cmiSubagents: 'ตัวแทนย่อย CMI',
  eventCalendar: 'ปฏิทินกิจกรรม',
  commission: 'ค่าคอมมิชชัน',
  downloadDocuments: 'ดาวน์โหลดเอกสาร',
  agentTransfers: 'โอนเงินตัวแทน',
  commissions: 'ค่าคอมมิชชัน',
  dashboard: 'แดชบอร์ด',
  referrals: 'การแนะนำ',
  leadGenerationCodes: 'รหัสสร้างลีด',
  debtCollectionCRM: 'CRM ติดตามหนี้',
  accounting: 'บัญชี',
  agent: 'ตัวแทน',
  insurer: 'ผู้รับประกัน',
  instalments: 'ผ่อนชำระ',
  credits: 'เครดิต',
  insurerTables: 'ตารางผู้รับประกัน',
  uploadWHTCertificate: 'อัปโหลดหนังสือรับรองภาษีหัก ณ ที่จ่าย',
  priceListAdmin: 'จัดการราคา',
  preQuoteSLA: 'Pre-Quote SLA',
  promotionAdmin: 'จัดการโปรโมชั่น',
  packagePromotion: 'โปรโมชั่นแพ็กเกจ',
  campaignPromotion: 'โปรโมชั่นแคมเปญ',
  policyAdmin: 'จัดการกรมธรรม์',
  mtiCovidPolicy: 'กรมธรรม์ MTI Covid',
  vibCovidPolicy: 'กรมธรรม์ VIB Covid',
  policyTrackingIds: 'รหัสติดตามกรมธรรม์',
  cancellationTrackingIds: 'เลขติดตามพัสดุที่ทำยกเลิก',
  gamificationAdmin: 'จัดการเกมมิฟิเคชั่น',
  staffManagement: 'จัดการพนักงาน',
  manageStaff: 'จัดการพนักงาน',
  staffTiming: 'เวลาทำงานพนักงาน',
  manageLeave: 'จัดการวันลา',
  uploadSupportStaffCSV: 'อัปโหลด CSV พนักงานสนับสนุน',
  teamList: 'รายชื่อทีม',
  insurerSetting: 'ตั้งค่าผู้รับประกัน',
  insurerEmail: 'อีเมลผู้รับประกัน',
  insurerToggles: 'สวิตช์ผู้รับประกัน',
  nonMotorInsurerEmail: 'อีเมลสำหรับแจ้งงาน Non Motor',
  refundRules: 'กฎการคืนเบี้ยประกัน',
  bannerUpload: 'อัปโหลดแบนเนอร์',
  highlightUpload: 'อัปโหลดไฮไลท์',
  announcementUpload: 'อัปโหลดประกาศ',
  commissionHighlight: 'ไฮไลท์ค่าคอมมิชชัน',
  promotionHighlight: 'ไฮไลท์โปรโมชั่น',
  announcementInventory: 'สินค้าคงคลังประกาศ',
  holidays: 'วันหยุด',
  printingAndDelivery: 'พิมพ์และจัดส่ง',
  crm: 'CRM',
  crmAffiliate: 'CRM พันธมิตร',
  staffForTask: 'พนักงานสำหรับงาน',
  generateTrackableLink: 'สร้างลิงก์ที่ติดตามได้',
  generateShortenedURL: 'สร้าง URL แบบย่อ',
  historicalReportRequests: 'คำขอรายงานประวัติ',
  csvUpload: 'อัปโหลด CSV',
  irSettings: 'ตั้งค่า IR',
  preSaleSLA: 'Pre-Sale SLA',
  policyIssuanceSLA: 'Policy Issuance SLA',
  coaForm: 'แบบฟอร์ม COA',
  insurerTier: 'ระดับผู้รับประกัน',
  affiliateSpecificCommissionRates: 'ค่าคอมมิชชันตามพันธมิตร',
  insurerRanking: 'อันดับบริษัทประกัน',
  commissionPromotions: 'ค่าคอมมิชชันและโปรโมชั่น',
  chatwootPayments: 'ช็อตวอทประมวลผล',
  assignmentConfig: 'การกำหนดค่าการมอบหมาย',
  notificationsAdmin: 'การแจ้งเตือน',
  profile: 'โปรไฟล์',
  logout: 'ออกจากระบบ',
  language: 'ภาษา',
  theme: 'ธีม',
  themeLight: 'สว่าง',
  themeDark: 'มืด',
};
